import React, { useEffect, useState } from "react";
import axiosApi from "core/request";
import i18n from "i18n";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

import { Button, Menu, MenuItem } from "@mui/material";

import { langs } from "../../i18n";

import styles from "./ResetPassword.module.scss";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [timer, setTimer] = useState(60);
  const [isLoading, setIsLoading] = useState(false);
  const email = localStorage.getItem("resetEmail");

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const resendEmail = async () => {
    if (!email || timer > 0) return;
    setIsLoading(true);
    try {
      await axiosApi.post("account/sendresetpasswordtoken", { email });
      setTimer(60);
    } catch (error) {
      console.error("Ошибка при повторной отправке:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isLanguageDropDownOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={styles.reset_password_container}>
      <div className={styles.reset_password_center_block}>
        <div className={styles.langToggle}>
          <Button
            variant="text"
            sx={{
              textTransform: "capitalize",
              fontSize: "1.1rem",
              color: "#0b4d88",
            }}
            id="basic-button"
            aria-controls={isLanguageDropDownOpen ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={isLanguageDropDownOpen ? "true" : undefined}
            onClick={handleClick}
          >
            {t("loginForm.dropDownLabel")}
          </Button>
          <Menu
            id="basic-menu"
            sx={{
              boxShadow: "0 4.8px 14.4px rgba(0,0,0,18)",
            }}
            anchorEl={anchorEl}
            open={isLanguageDropDownOpen}
            onClose={handleClose}
          >
            {langs.map((lng) => (
              <MenuItem
                key={lng}
                onClick={() => {
                  i18n.changeLanguage(lng);
                  handleClose();
                }}
              >
                {i18n.t(`languages.${lng}`)}
              </MenuItem>
            ))}
          </Menu>
        </div>
        <div className={styles.icon}>
          <span className={styles.checkmark}>✔</span>
        </div>
        <h2 className={styles.title}>{t("resetPassword.almostDone")}</h2>
        <p className={styles.subtitle}>
          {t("resetPassword.linkWasSent")} <b>{email}</b>
        </p>

        {timer > 0 ? (
          <p className={styles.resend_text}>
            <span className={styles.resend_link}>
              {t("resetPassword.sendAgainIn")}
            </span>{" "}
            <span className={styles.timer}>
              00:{timer < 10 ? `0${timer}` : timer}
            </span>
          </p>
        ) : (
          <button
            className={styles.resend_button}
            onClick={resendEmail}
            disabled={isLoading}
          >
            {isLoading ? "Sending..." : t("resetPassword.sendAgain")}
          </button>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
